import recursosHumanos from './recursosHumanos'
import cadastros from './cadastros'

export default [
  ...cadastros,
  ...recursosHumanos,
];
